










































































































































import { Vue, Component } from "../vue-ext";
import { ParkingArea, ParkingSlot, Account, ParkingSlotType, HousingCompany, Apartment } from "../models";
import "../components/YesNoPopup";

@Component
export default class ParkingView extends Vue {
    private parkingAreas: ParkingArea[] | null = null;
    private selectedParkingAreaName: string = "";
    private account: Account | null = null;
    private housingCompany: HousingCompany | null = null;
    private ownSlots: any[] = [];
    private selectedRowId: string | null = null;
    ParkingSlotType = ParkingSlotType;
    private selectedParkingSlot: ParkingSlot | null = null;
    private selectedOwnSlot: any | null = null;
    private confirmOpen: boolean = false;
    private confirmRemoveOpen: boolean = false;
    private loading: boolean = true;
    private selectedApartmentId: number | null = null;
    private apartmentList: Apartment[] | null = null;
    private startFrom: Date | null = null;

    private async created() {
        this.root.setTitle(this.$t("menu.parkingSpaces") as string);
        this.root.setIconClass("icon-autopaikkavaraukset");

        this.account = this.root.getCurrentAccount() as Account;
        this.housingCompany = this.root.getCurrentHousingCompany() as HousingCompany;

        if (!this.account.isVerified) {
            return;
        }

        this.parkingAreas = this.root.parkingAreas; // await this.root.service.parking.GetParkingAreas(this.housingCompany.housingCompanyId);

        if (this.parkingAreas) {
            this.selectedParkingAreaName = this.parkingAreas[0].name;

            this.apartmentList = await this.root.service.user.GetApartments(this.housingCompany.housingCompanyId);

            if (this.apartmentList && this.apartmentList.length > 0) {
                this.selectedApartmentId = this.apartmentList[0].apartmentId;
            }

            for (let i = 0; i < this.parkingAreas.length; i++) {
                for (let j = 0; j < this.parkingAreas[i].slots.length; j++) {
                    if (this.parkingAreas[i].slots[j].isOwn) {
                        this.ownSlots.push({ 
                            area: this.parkingAreas[i].name,
                            slot: this.parkingAreas[i].slots[j].name, 
                            removed: false, 
                            type: this.parkingAreas[i].slots[j].type,
                            types: this.parkingAreas[i].slots[j].types,
                            apartmentId: this.parkingAreas[i].slots[j].apartmentId
                        });
                    }
                }
            }
        }

        this.loading = false;
    }

    private parkingSlots(): ParkingSlot[] | null {
        if (this.parkingAreas) {
            const area = this.parkingAreas.find(a => a.name === this.selectedParkingAreaName) as ParkingArea;
            return area.slots;
        }

        return [];
    }

    private async reserve(slot: ParkingSlot) {
        this.selectedParkingSlot = slot;
        this.confirmOpen = true;
    }

    private confirmText(): string {
        if (this.parkingAreas && this.selectedParkingSlot) {
            const area = this.parkingAreas.find(s => s.name === this.selectedParkingAreaName) as ParkingArea;

            return this.$t("parkingView.confirmReservation",  [ this.selectedParkingSlot.name, area.name ]) as string
        }

        return "";
    }

    private async confirmYes() {
        if (this.account && this.parkingAreas && this.selectedParkingSlot && this.selectedApartmentId && this.startFrom) {
            const area = this.parkingAreas.find(s => s.name === this.selectedParkingAreaName) as ParkingArea;

            const result = await this.root.service.parking.Reserve(this.account.accountId, area.name, this.selectedParkingSlot.name, this.selectedApartmentId, this.startFrom);

            if (!result.isError) {
                this.selectedParkingSlot.isAvailable = false;
                this.selectedParkingSlot.reserved = true;
            }
        }
        
        this.confirmOpen = false;
    }

    private confirmNo() {
        this.selectedParkingSlot = null;
        this.confirmOpen = false;
    }

    private async remove() {
        this.confirmRemoveOpen = true;
    }

    private confirmRemoveText(): string {
        if (this.selectedOwnSlot) {
            return this.$t("parkingView.confirmRemoveReservation",  [ this.selectedOwnSlot.area, this.selectedOwnSlot.slot]) as string
        }

        return "";
    }

    private async confirmRemoveYes() {
        if (this.selectedOwnSlot && this.account) {
            const result = await this.root.service.parking.RemoveReservation(this.account.accountId, this.selectedOwnSlot.area, this.selectedOwnSlot.slot, this.selectedOwnSlot.apartmentId);

            if (!result.isError) {
                this.selectedOwnSlot.removed = true;
            }
        }
        
        this.confirmRemoveOpen = false;
    }

    private confirmRemoveNo() {
        this.confirmRemoveOpen = false;
    }
}
